module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img2-d74a3b1eeb2d4a85c15eb7183eee4534.svg";